import { Navigate, useLocation } from 'react-router-dom';

/**
 * Like <Navigate />, but preserves the current URL's query string.
 * React Router's <Navigate to="information" replace /> drops search params;
 * this component carries them through the redirect.
 */
const NavigatePreserveSearch = ({
  to,
  replace,
}: {
  to: string;
  replace?: boolean;
}) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace={replace} />;
};

export default NavigatePreserveSearch;
